import React from "react";
import { Container, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import TitleHelmet from "@/components/TitleHelmet";
import AccountLocationsList from "@/features/accounts/components/AccountLocationsList";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./account-locations.module.scss";

const AccountLocations: React.FC = () => {
  const { companyNumber: rawId } = useParams<{ companyNumber: string }>();
  const masterAccountId = rawId ? decodeURIComponent(rawId) : "";

  return (
    <React.Fragment>
      <TitleHelmet title="Client Locations" />
      <Container fluid>
        <Card className={styles.card}>
          <Card.Body>
            <AccountLocationsList masterAccountId={masterAccountId} />
          </Card.Body>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default withAuthenticationRequired(AccountLocations);
